import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=ef597fae&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef597fae",
  null
  
)

export default component.exports